// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 8.25V12.2C3 13.3 3.9 14.2 5 14.2H11C12.1 14.2 13 13.3 13 12.2V8.25M8 8.25V14.2',
  'M8 5.5C7.63 3.33 6.23 1.8 4.8 1.8C3.81 1.8 3 2.61 3 3.6C3 4.65 3.88 5.5 5.4 5.5H8ZM8 5.5C8.37 3.33 9.77 1.8 11.2 1.8C12.19 1.8 13 2.61 13 3.6C13 4.65 12.12 5.5 10.6 5.5H8Z',
  'M2.85 5.5H13.15C13.62 5.5 14 5.88 14 6.35V7.4C14 7.87 13.62 8.25 13.15 8.25H2.85C2.38 8.25 2 7.87 2 7.4V6.35C2 5.88 2.38 5.5 2.85 5.5Z',
];
